<template>
  <div id="app">
    <message-center />
    <message-box />
    <router-view v-if="$route.name === 'login'" />
    <app-shell v-else />
  </div>
</template>

<script>
import AppShell from './components/AppShell.vue'
import MessageCenter from './components/MessageCenter.vue'
import MessageBox from './components/MessageBox.vue'

export default {
  name: 'App',
  components: { AppShell, MessageCenter, MessageBox }
}
</script>
